module["exports"] = [" do Descoberto", " de Nossa Senhora", " do Norte", " do Sul"];